import React from 'react';

function ViewForm(data: any) {
    return (<div aria-label={data.ariaLabel} id={data.id} className={"viewFormContainer"}>
        <span><b>{data.label}:</b></span>
        <span style={data.styles}>&nbsp;{data.value}</span>
    </div>);
}

export default ViewForm;